<template>
  <main id="genericServiceDesk-page" class="template__content__align-between">
    <div class="template__content__align-center">
      <div class="flex-vertical-center">
        <div class="genericServiceDesk__content padding-x-15">
          <div class="icon-circle" v-if="bodyConfig.showIconClass">
            <component :is="bodyProps.iconComponent" v-if="bodyProps.iconComponent" />
            <span :class="['di', bodyProps.iconClass || body.iconClass]" v-else></span>
          </div>

          <br />

          <h1 v-if="bodyConfig.showTitle">{{ bodyProps.title || body.title }}</h1>

          <br />

          <p id="genericservicedesk-p-name" v-if="bodyConfig.showSubtitleArea">
            <template v-if="bodyConfig.showName"> {{ userFirstName }}, </template>
            <template v-if="bodyConfig.showSubtitle">
              {{ bodyProps.subtitle || body.subtitle }}
            </template>

            <template v-if="bodyConfig.showList">
              <ul>
                <li v-for="(item, index) in list" :key="index">
                  {{ item }}
                </li>
              </ul>
            </template>
          </p>
        </div>
      </div>
    </div>

    <div>
      <div class="flex flex-justify-content--center">
        <VButton
          id="genericservicedesk-link-end"
          :text="bodyProps.btnLabel || body.btnLabel"
          :variant="bodyProps.btnLayout"
          @click.native="endService"
        ></VButton>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'GenericServiceDesk',
  mixins: [dataLayersMixin],
  data() {
    return {
      body: {
        iconClass: 'di-icon-altaAttendant',
        title: 'Você precisará ser atendido em um guichê com senha',
        subtitle:
          'ao chegar à unidade, retire uma senha para realizar seu atendimento com um de nossos atendentes.',
        btnLabel: 'Finalizar Atendimento',
        btnLayout: null,
        iconComponent: false,
        list: [],
        config: {
          showIconClass: true,
          showTitle: true,
          showName: true,
          showSubtitle: true,
          showSubtitleArea: true,
          showList: false,
        },
      },
    };
  },

  computed: {
    ...mapState({
      payment: ({ currentAdmission }) => currentAdmission.data.payments[0],
    }),

    ...mapGetters({
      userFirstName: 'global/userFirstName',
      typeOfAdmission: 'haveScheduledExams',
    }),
    bodyProps() {
      return {
        iconClass: this.$route?.meta.body?.iconClass,
        iconComponent: this.getRightValue('iconComponent'),
        title: this.getRightValue('title'),
        subtitle: this.$route?.meta.body?.subtitle,
        list: this.$route?.meta.body?.list,
        nextView: this.$route?.meta.body?.nextView,
        btnLabel: this.$route?.meta.body?.btnLabel,
        btnLayout: this.$route?.meta.body?.btnLayout,
      };
    },
    bodyConfig() {
      return {
        showIconClass: this.getRightValue('showIconClass', true),
        showTitle: this.getRightValue('showTitle', true),
        showName: this.getRightValue('showName', true),
        showSubtitle: this.getRightValue('showSubtitle', true),
        showSubtitleArea: this.getRightValue('showSubtitleArea', true),
        showList: this.getRightValue('showList', true),
        goToEndFlow: this.getRightValue('goToEndFlow', false),
      };
    },
    list() {
      return this.bodyProps.list || this.body.list;
    },
    isExamErrorRoute() {
      return this.$route.name.includes('service-desk-exams');
    },
  },
  methods: {
    ...mapActions({
      setAdmissionNotElegible: 'setAdmissionNotElegible',
      setServicesChanged: 'global/setServicesChanged',
    }),
    ...mapMutations({
      setRequestedChanges: 'HAS_CHANGED_SERVICES',
    }),
    getRightValue(propName, isConfig = false) {
      if (isConfig) {
        const routerValue = this.$route?.meta.body?.config;
        return routerValue !== undefined &&
          Object.prototype.hasOwnProperty.call(routerValue, propName)
          ? routerValue[propName]
          : this.body.config[propName];
      }
      const routerValue = this.$route.meta?.body;
      return routerValue !== undefined &&
        Object.prototype.hasOwnProperty.call(routerValue, propName)
        ? routerValue[propName]
        : this.body[propName];
    },

    async endService() {
      this.setServicesChanged(true);

      if (this.bodyConfig.goToEndFlow) {
        this.goNextStep('end_flow_success');
        return;
      }

      if (this.isExamErrorRoute) {
        await this.setAdmissionNotElegible();
        this.setRequestedChanges();
        this.goNextStep(this.bodyProps.nextView);
        return;
      }

      if (this.$route?.meta.reason === 'health insurance not accepted') {
        this.goNextStep('end_flow_success');
        return;
      }

      this.goNextStep('checkin_step');
    },
  },
  created() {
    const origin = this.$route?.params?.origin;
    const error = this.$route?.params?.error;
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Alterar serviços',
      origin,
      error,
    });
  },
};
</script>

<style lang="scss" scoped>
.icon-circle {
  margin: 0 auto;

  .di:before {
    color: var(--color-primary);
    font-size: 55px;
  }

  path {
    fill: var(--color-primary);
  }
}
ul {
  text-align: left;
  padding-left: 20px;
  margin-top: 10px;
  list-style: disc;

  li + li {
    margin-top: 20px;
  }
}
</style>
